module.exports = __webpack_public_path__ + "static/media/LogoDE.93076174.svg";